/*eslint-disable*/
import api from '../'

class ShutterApi {
    // get: /words-field/groups
    static getGroups (locale) {
        return api.axios.get('/shutter/groups', {
            params: {
                locale
            }
        }).then(response => response.data);
    }

    static getTexts (locale) {
        return api.axios.get('/shutter/texts', {
            params: {
                locale
            }
        }).then(response => response.data.texts);
    }

    static getItems (params) {
        return api.axios.get('/shutter/items', {
            params
        }).then(response => response.data.items);
    }

    static checkIfEnoughWords(params) {
        return api.axios.get('/shutter/check-if-enough-words', {
            params
        }).then(response => response.data);
    }
}

export default ShutterApi;
